/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHexagonExclamationFill: {
  name: 'hexagon-exclamation-fill';
  data: string;
} = {
  name: 'hexagon-exclamation-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.414 2A2 2 0 0 0 7 2.586L2.586 7A2 2 0 0 0 2 8.414v7.172A2 2 0 0 0 2.586 17L7 21.414A2 2 0 0 0 8.414 22h7.172A2 2 0 0 0 17 21.414L21.414 17A2 2 0 0 0 22 15.586V8.414A2 2 0 0 0 21.414 7L17 2.586A2 2 0 0 0 15.586 2H8.414ZM13 8a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
